// Writing CSV files that open correctly in spreadsheets, whatever people type into names and notes

// text starting with one of these is run as a formula by Excel and other spreadsheets, which can do harm when a
// downloaded file is opened
const FORMULA_START = /^[=+\-@\t\r]/

// one value, quoted when it contains a comma, quote or line break (quotes doubled), and with text that would be taken
// as a formula made plain. Numbers, dates and booleans are written as they are; nothing becomes an empty field
export const csvField = (value:unknown):string => {
    if (value === undefined || value === null) return ''
    if (typeof value === 'number') return isFinite(value) ? String(value) : ''
    if (value instanceof Date) return isNaN(value.getTime()) ? '' : value.toISOString()

    let text = String(value)
    if (FORMULA_START.test(text) && isNaN(Number(text))) text = "'" + text
    return /[",\r\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text
}

export const csvRow = (values:unknown[]) => values.map(csvField).join(',')

// a header row and the data rows, with Windows line endings as spreadsheets expect
export const toCsv = (header:unknown[], rows:unknown[][]) => [header, ...rows].map(csvRow).join('\r\n')
